import { notification } from 'antd';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { postUpdateCommentTemplate, uploadMultipleCommentsExcel } from './commentApis';
import { CommentQueryKeys } from './commentQueries';

export const useUpdateCommentTemplate = (closeModal: () => void) => {
  const queryClient = useQueryClient();

  return useMutation('postUpdateCommentTemplate', postUpdateCommentTemplate, {
    onSuccess: () => {
      queryClient.invalidateQueries(CommentQueryKeys.GET_COMMENT_LIST);
      notification.success({ description: 'The comment template is updated successfully!', message: 'Update Comment Template' });
      closeModal();
    },
    onError: () => {
      notification.error({ description: 'The comment template has failed to update!', message: 'Update Comment Template' });
    },
  });
};

export const useMultipleCommentsExcelUpload = (closeModal: () => void) => (
  useMutation('uploadMultipleCommentsExcel', uploadMultipleCommentsExcel, {
    onSuccess: (data) => {
      const description = data.data.msg || 'Successfully uploaded excel file.';
      closeModal();
      notification.success({ message: 'Upload Multiple Comments Excel', description });
    },
    onError: (error: AxiosError<CapBayApiError>) => {
      const errorMsg = error.response?.data.error.message;
      if (errorMsg) {
        notification.error({ message: 'Upload Multiple Comments Excel', description: errorMsg });
      } else {
        notification.error({ message: 'Upload Multiple Comments Excel', description: 'Something went wrong. Please try again later.' });
      }
    },
  })
);
